@if (titleLabel) {
  <p style="font-weight:bold;">{{titleLabel}}</p>
}
@if (blobs && blobs.length == 0 && viewOnly && !hideIfNoBlobs) {
  <p>None</p>
}
@if (blobs && !viewOnly) {
  <div>
    <label>
      @if (accept) {
        <input
          aria-label="Upload file"
          title="Upload File"
          type="file"
          id="blobUpload"
          [name]="containerName"
          [required]="isRequired"
          style="display:none !important"
          [(ngModel)]="fileInUploader"
          [accept]="accept"
          (change)="addToList($event.target.files[0])"
          pInputText/>
      }
      @if (!accept) {
        <input
          aria-label="Upload file"
          title="Upload File"
          type="file"
          id="blobUpload"
          [name]="containerName"
          style="display:none !important"
          [(ngModel)]="fileInUploader"
          (change)="addToList($event.target.files[0])"
          pInputText/>
      }
      <span style="vertical-align: middle;">
        @if (!buttonText) {
          <i class="pi pi-plus fake-button"></i>
        }
        @if (buttonText) {
          <div style="padding: 6px;">{{buttonText}}</div>
        }
      </span>
    </label>
    @if (!buttonText) {
      <span> Add {{uploadLabel}}</span>
    }
  </div>
}
@if (!blobs && !errorMessage && !hideIfNoBlobs) {
  <p>Loading list...</p>
}
@if (errorMessage && !hideIfNoBlobs) {
  <p>{{errorMessage}}</p>
}
@for (blob of displayBlobs; track blob; let b = $index) {
  <div [ngStyle]="{'margin-bottom': viewOnly ? '0px' : '12px'}">
    <div style="vertical-align: middle;">
      @if (!viewOnly) {
        <p-button type="button" severity="danger" icon="pi pi-times" (click)="delete(blob, b)"></p-button>
      }
      <span>
        &nbsp;<a style="vertical-align: middle;" class="regular-link" [href]="blob.SASUri">{{blob.DisplayName}}</a>
      </span>
    </div>
  </div>
}
@for (file of filesToUpload; track file; let f = $index) {
  <div>
    <div class="ui-inputgroup">
      <p-button type="button" icon="pi pi-times" severity="danger" (click)="removeFromList(f)"></p-button>
      <span>
        &nbsp;<a style="vertical-align: middle;" class="regular-link">{{file.overwrittenFileName}}</a>
        @if (file && file.showDone) {
          <span class="done"><i class="pi pi-check"></i> Upload complete</span>
        }
      </span>
      @if (angularUpload && file.progress >= 0) {
        <div style="width: 190px; padding-left: 5px; padding-top: 5px">
          @if (file.progress != 100) {
            <p-progressBar [value]="file.progress"></p-progressBar>
          }
        </div>
      }
      @if (file.canRetry) {
        <p-button type="button" icon="pi pi-refresh" class="ui-button-warning" (click)="retryFile(file)"></p-button>
      }
    </div>
  </div>
}